

  import Vue from 'vue'
  import Component from "vue-class-component";

  @Component({
    name: 'home',
  })
  export default class HomeView extends Vue {

    get shortcuts() {
      return [
        { icon: 'mdi-view-dashboard', label: this.$t('home.shortcuts.lockers'), to: { name: 'lockerList' }, route: 'lockers' },
        { icon: 'mdi-account-group', label: this.$t('home.shortcuts.users'), to: { name: 'userList' }, route: 'users' },
        { icon: 'mdi-package-variant-closed', label: this.$t('home.shortcuts.orders'), to: { name: 'orderList' }, route: 'orders' },
        { icon: 'mdi-cube-send', label: this.$t('home.shortcuts.providers'), to: { name: 'serviceProviderList' }, route: 'providers' },
        { icon: 'mdi-chart-bar', label: this.$t('home.shortcuts.reports'), to: { name: 'reports' }, route: 'reports' },
        { icon: 'mdi-cog', label: this.$t('home.shortcuts.settings'), to: { name: 'channels' }, route: 'settings' },
      ];
    }

  }

